import {
    useCallback,
} from 'react'

import {
    useMutation,
} from '@tanstack/react-query'

import simpleApi from 'app/services/simpleApi'
import {
    useJWTToken,
} from 'app/Auth'

import useHandleStatusRequest from 'app/hooks/useHandleStatusRequest'

import requests from 'app/requests/Lane/LaneStatus.requests'

export default ({
    onSuccess,
}: {
    onSuccess: (...args: any[]) => void,
}) => {
    const token = useJWTToken()

    const {
        onSuccess: onSuccessLaneStatusUpdate,
        onError,
    } = useHandleStatusRequest({
        title: 'Lane was awarded',
        id: 'AwardLane',
        onSuccess,
    })

    const {
        mutate: award,
    } = useMutation({
        mutationFn: (id: number) => {
            return simpleApi({
                ...requests.setAsAwarded({
                    id,
                }),
                token,
            })
        },
        onError,
        onSuccess: onSuccessLaneStatusUpdate,
    })

    return useCallback((id: number) => {
        award(id)
    }, [award])
}
